import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default {
  __name: 'TierHeader',
  props: {
  tierId: { type: String, required: true },
  tierName: { type: String, default: '' },
  parent: { type: Object, required: true },
  sections: { type: Array, default: undefined },
  canMove: { type: Boolean, default: false }
},
  emits: ['move'],
  setup(__props, { emit: __emit }) {



const emit = __emit

return (_ctx, _cache) => {
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_router_link = _resolveComponent("router-link")
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")

  return (_openBlock(), _createBlock(_component_SecondaryTop, {
    text: __props.tierName,
    parent: __props.parent,
    sections: __props.sections,
    "save-status": false
  }, {
    right: _withCtx(() => [
      _createVNode(_component_NeueButton, {
        type: "secondary",
        disabled: !__props.canMove,
        onClick: _cache[0] || (_cache[0] = $event => (emit('move')))
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Move members", -1)
        ]))]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_router_link, {
        to: `/store/membership-tiers/${__props.tierId}/edit`
      }, {
        default: _withCtx(() => [
          _createVNode(_component_NeueButton, { type: "primary" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Edit tier", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _: 1
  }, 8, ["text", "parent", "sections"]))
}
}

}